@if (form$ | async; as form) {
  <div class="frame">
    <div class="c-list-items-header">
      <div class="c-list-items-header-content">
        <p class="c-list-items-header-text c-list-items-header-text--required">
          {{ 'orderCancellation.cancellationAndReturn.selectItems' | cxTranslate }}
        </p>
        @if (!isConfirmation) {
          <label class="form-check form-check-inline c-list-items-header-check-box">
            <input type="checkbox" [checked]="checkAll" (change)="onCheckAllChange(form, $event)"/>
            <span class="c-list-items-header-check-box-text">{{ 'orderCancellation.cancellationAndReturn.selectAll' | cxTranslate }}</span>
          </label>
        }
      </div>
    </div>
    <div class="cancel-or-return-list">
      <table class="table table--responsive">
        <thead>
          <tr>
            <th scope="col" class="text-left">{{ 'orderCancellation.cancellationAndReturn.article' | cxTranslate }}</th>
            <th scope="col" class="text-lg-center">{{ 'orderCancellation.cancellationAndReturn.quantity' | cxTranslate }}</th>
            <th scope="col" class="text-lg-center">{{ 'orderCancellation.cancellationAndReturn.consignmentInfo' | cxTranslate }}</th>
            @if (!isConfirmation) {
              <th scope="col" class="text-lg-center"></th>
            }
          </tr>
        </thead>
        <tbody>
          @for (item of entries; track item; let i = $index) {
            <tr>
              <!-- Item article manufacturerAID -->
              <td attr.data-label="{{ 'orderCancellation.cancellationAndReturn.article' | cxTranslate }}">
                <!-- Item article name -->
                @if (item.product.name) {
                  <div class="cx-name u-font-bold">
                    {{ item.product.name }}
                    @if (item.product.baseOptions?.length) {
                      @for (
                        variant of item.product.baseOptions[0]?.selected
                        ?.variantOptionQualifiers
                        ; track
                        variant) {
                        <div
                          class="cx-property">
                          @if (variant.name) {
                            <div class="cx-label">
                              {{ variant.name }}:
                            </div>
                          }
                          @if (variant.value) {
                            <div class="cx-value">
                              {{ variant.value }}
                            </div>
                          }
                        </div>
                      }
                    }
                  </div>
                }
                @if (item.product.manufacturerAID) {
                  <div>
                    {{ item.product.manufacturerAID }}
                    @if (item.product.manufacturer) {
                      <span
                      >&nbsp;/&nbsp;{{ item.product.manufacturer }}</span>
                    } @else {
                      @if (item.product.manufacturerId) {
                        <span
                        >&nbsp;/&nbsp;{{ item.product.manufacturerId }}</span>
                      }
                    }
                  </div>
                }
                <!-- Item SubstitutedOemNumber -->
                @if (item.substitutedOemNumber) {
                  <div>
                    <span
                      class="u-font-bold">{{ 'orderCancellation.cancellationAndReturn.searchedArticleNumber' | cxTranslate }}
                    :&nbsp;</span>
                    <span>{{ item.substitutedOemNumber }}</span>
                  </div>
                }
              </td>
              <!-- Item article quantity -->
              <td attr.data-label="{{ 'orderCancellation.cancellationAndReturn.quantity' | cxTranslate }}" class="table-col-quantity">
                <div class="cx-value text-lg-center">
                  {{ item.quantity }}
                </div>
              </td>
              <!-- Item article consignmentInfo -->
              <td attr.data-label="{{ 'orderCancellation.cancellationAndReturn.consignmentInfo' | cxTranslate }}" class="table-col-consignment-info">
                @if (item.consignmentInfo) {
                  <div class="text-lg-center">
                    {{ item.consignmentInfo }}
                  </div>
                }
              </td>
              @if (!isConfirmation) {
                <td attr.data-label="{{ 'orderCancellation.cancellationAndReturn.selectItem' | cxTranslate }}" class="table-col-select">
                  <div class="form-check text-lg-center">
                    <input type="checkbox"
                      class="mt-0"
                      [checked]="getFormModel(item)"
                      (change)="onCheckChange(form, item, $event)"/>
                    </div>
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
        @if (!isConfirmation && form.invalid) {
          <div class="row">
            <div class="col-12">
              <span class="cancel-or-return-list-selection-hint">
                <small class="cancel-or-return-list-selection-hint-text">
                  {{ 'orderCancellation.selectedHint' | cxTranslate }}
                </small>
              </span>
            </div>
          </div>
        }
      </div>
    </div>
  }
